export default function industries(state = [], action) {
  switch(action.type) {
    case 'UPDATE_INDUSTRIES':
      return action.industries;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/industries.js